import { DefaultPageTemplate } from '@@/common/components/default-page-template';
import { Responses } from '@consta/uikit/Responses';
import { Link } from 'react-router-dom';
import { UiButton } from '@@/ui/components/ui-button';

import styles from './index.module.sass';
import ResponseLogo from '../../images/ResponseLogo';

import { useEffect, useState } from 'react';
import { Spin } from 'antd';

export function NotFoundPage() {
  return (
    <DefaultPageTemplate className={styles.root}>
      <Responses
        image={ResponseLogo}
        title="Страница не найдена"
        description={
          <>
            Такой страницы нет<br />
            Возможно, в вашей ссылке ошибка
          </>
        }
        actions={
          <Link to="/">
            <UiButton label="На главную" />
          </Link>
        }
      />
    </DefaultPageTemplate>
  );
}
